<template>
  <div class="bg-img">
    <div style="position: absolute; left: 52px; top: 34px">
      <img :src="logoSrc" style="width:140px;40px;"/>
    </div>
    <el-container
      style="
        position: absolute;
        right: 200px;
        top: calc(50% - 195px);
        width:400px;
        background: #fff;
        border-radius: 10px;
        padding: 20px 9px 0;
      "
    >
      <!-- <el-header style="display: flex;height:40px;">
        <div class="login-title" :class="{ 'active-login-title': loginType == 0 }">
          <span @click="switchLogin(0)">{{ $t('login.loginType') }}</span>
          <div></div>
        </div>
        <div class="login-title" :class="{ 'active-login-title': loginType == 1 }">
          <span @click="switchLogin(1)">手机登录</span>
          <div></div>
        </div>
      </el-header> -->
      <el-main v-if="loginType == 0" style="overflow-y: hidden">
        <el-form ref="pwdLoginForm" :model="pwdLoginForm">
          <el-form-item prop="username">
            <el-input v-model="pwdLoginForm.username" auto-complete="username" name="username" placeholder="请输入用户名"
              ><i slot="prefix" class="custom-icon yh-icon"></i
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="pwdLoginForm.password" auto-complete="current-password" name="password" placeholder="请输入密码" type="password"
              ><i slot="prefix" class="custom-icon mm-icon"></i
            ></el-input>
          </el-form-item>
          <el-form-item v-if="captchaEnabled" prop="code">
            <el-input v-model="pwdLoginForm.code" auto-complete="off" name="code" placeholder="请输入验证码" style="width: 72%"
              ><i slot="prefix" class="custom-icon yzm-icon"></i
            ></el-input>
            <img
              :src="codeUrl"
              style="
                width: 121px;
                height: 50px;
                border: 1px solid #e9e9e9;
                border-radius: 10px;
                margin-left: 6px;
                margin-bottom: -20px;
              "
              @click="getCode"
              alt="验证码"
            />
          </el-form-item>
          <!-- <el-form-item style="color: #666;margin-bottom:0;">
            <el-checkbox v-model="pwdLoginForm.rememberMe" style="font-size: 20px; color: #848587"
              >记住密码</el-checkbox
            >
            <span style="font-size:16px;margin-left: 187px">忘记密码</span>
          </el-form-item> -->
          <el-form-item style="border-bottom: 0">
            <el-button
              type="primary"
              style="width: 100%; height: 40px; border-radius: 7px; font-size:16px;"
              @click="onLogin"
              >立即登录</el-button
            >
          </el-form-item>
          <!-- <el-form-item style="height: 40px;">
            <span class="wxLine"></span>
            <span style="font-size: 12px; color: #97c8ff;margin:0 3px;">微信小程序扫码登录</span>
            <span class="wxLine"></span>
          </el-form-item>
          <el-form-item style="text-align: center;height:63px;">
            <img :src="wxSrc" />
          </el-form-item> -->
        </el-form>
      </el-main>
      <!-- <el-main v-else style="overflow:hidden;">
        <el-form ref="phoneLoginForm" :model="phoneLoginForm">
          <el-form-item>
            <el-input
              v-model="phoneLoginForm.username"
              prefix-icon="el-icon-user-solid"
              placeholder="请输入电话号码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="phoneLoginForm.password"
              prefix-icon="el-icon-lock"
              placeholder="请输入短信验证码"
            ></el-input>
          </el-form-item>
          <el-form-item style="border-bottom: 0">
            <el-button
              type="primary"
              style="width: 100%; height: 40px; border-radius: 7px; font-size: 16px"
              @click="onLogin"
              >立即登录</el-button
            >
          </el-form-item>
          <el-form-item style="height:40px;">
            <span class="wxLine"></span>
            <span style="font-size: 12px; color: #97c8ff;margin:0 3px;">微信小程序扫码登录</span>
            <span class="wxLine"></span>
          </el-form-item>
          <el-form-item style="text-align:centerh;height:63px;">
            <img :src="wxSrc" />
          </el-form-item>
        </el-form>
      </el-main> -->
    </el-container>
    <span
      style="position: absolute; width: 100%; display: inline-block; font-size:12px;text-align: center; bottom: 35px; color: rgba(187, 187, 187, 1)"
      >版权所有@2024深圳市星石智联科技有限公司</span
    >
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      pwdLoginForm: {
        tenantId: '000000',
        username: '',
        password: '',
        code: '',
        // rememberMe: true,
        uuid: ''
      },
      codeUrl: '',
      phoneLoginForm: {},
      loginForm: null,
      captchaEnabled: false, //是否显示验证码
      wxSrc: require('../../assets/login/weixin.jpg'),
      logoSrc: require('../../assets/login/logo.png'),
      loginType: 0 //登录方式，0-密码登录，1-手机登录
    };
  },
  methods: {
    /**
     * 获取验证码
     */
    async getCode() {
      const res = await this.$store.dispatch('login/getCodeImg');
      if (res) {
        const { data } = res;
        this.captchaEnabled = data.captchaEnabled === undefined ? true : data.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + data.img;
          this.phoneLoginForm.uuid = data.uuid;
        }
      }
    },
    async onLogin() {
      if (this.loginType == 0) {
        // this.loginForm = this.pwdLoginForm;
        this.loginForm = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.pwdLoginForm).filter(([key, value]) => value !== '')
        );
      } else {
        // this.loginForm = this.phoneLoginForm;
        this.loginForm = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.phoneLoginForm).filter(([key, value]) => value !== '')
        );
      }

      // 勾选了需要记住密码设置在 localStorage 中设置记住用户名和密码
      if (this.loginForm.rememberMe) {
        localStorage.setItem('username', String(this.loginForm.username));
        localStorage.setItem('password', String(this.loginForm.password));
        localStorage.setItem('rememberMe', String(this.loginForm.rememberMe));
      } else {
        // 否则移除
        localStorage.removeItem('username');
        localStorage.removeItem('password');
        localStorage.removeItem('rememberMe');
      }

      const result = await this.$store.dispatch('login/login', this.loginForm);
      if (result.code == 200) {//登录成功
        this.$router.push('/homeboard').catch(err => {});
      } else {
        // 重新获取验证码
        if (this.captchaEnabled) {
          await this.getCode();
        }
      }
    },
    // 切换登录方式
    switchLogin(flag) {
      if (flag == 0) {
        this.loginType = 0;
        // this.loginForm = this.pwdLoginForm;
        this.loginForm = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.pwdLoginForm).filter(([key, value]) => value !== '')
        );
      } else {
        this.loginType = 1;
        // this.loginForm = this.phoneLoginForm;
        this.loginForm = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.phoneLoginForm).filter(([key, value]) => value !== '')
        );
      }
    },
    getLoginData(){
      const tenantId = localStorage.getItem('tenantId');
      const username = localStorage.getItem('username');
      const password = localStorage.getItem('password');
      const rememberMe = localStorage.getItem('rememberMe');
      this.loginForm = {
        tenantId: tenantId === null ? String(this.phoneLoginForm.tenantId) : tenantId,
        username: username === null ? String(this.phoneLoginForm.username) : username,
        password: password === null ? String(this.phoneLoginForm.password) : String(password),
        rememberMe: rememberMe === null ? false : Boolean(rememberMe)
      };
    }
  },
  mounted(){
    this.getCode(); //获取验证码
    this.getLoginData();
    // if (this.captchaEnabled) {
      // await this.getCode(); //获取验证码
    // }
    // this.$store.dispatch('auth/login', this.form)
    // this.$router.push('/main');
  }
};
</script>

<style lang="scss" scoped>
.bg-img {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/login/bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
::v-deep .el-input__inner {
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
}
// .el-form-item {
//   margin-bottom: 0px;
// }
::v-deep .el-form-item__content{
  line-height: 48px;
}
.wxLine {
  display: inline-block;
  width: 113px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 4px;
}
.login-title {
  margin: 0 43px;
  font-size: 20px;
  color: #1b1b1b;
  line-height: 40px;
  cursor: pointer;
  div {
    display: none;
  }
}
.active-login-title {
  font-weight: bold;
  div {
    display: block;
    border-bottom: 5px solid #3083fb;
    width: 87px;
  }
}
.custom-icon {
  display: inline-block;
  width: 21px;
  height: 24px;
  margin: 13px 10px;
  background-repeat: no-repeat;
}
.yh-icon {
  background-image: url('../../assets/login/yonghu.jpg');
}
.mm-icon {
  background-image: url('../../assets/login/mima.jpg');
}
.yzm-icon {
  background-image: url('../../assets/login/yanzhengma.jpg');
}
::v-deep .el-input--prefix .el-input__inner {
  padding-left: 47px;
  font-size: 16px;
}
::v-deep .el-input__inner {
  color: #333;
}
::v-deep .el-checkbox__inner {
  width: 16px;
  height: 16px;
}
::v-deep .el-checkbox__label {
  font-size: 16px;
}
.el-checkbox__inner::after {
  height: 14px;
  left: 7px;
  top: 1px;
  width: 6px;
}
</style>
